
<template>
  <button :disabled="disabled" :class="buttonClass" v-on="$listeners" :aria-label="label">
    <span>
      <icon :name="light ? 'secondary_arrow_down_light' : 'secondary_arrow_down'" size="9px"></icon>
    </span>
  </button>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon.vue';
export default {
  name: 'ArrowButton',
  components: {
    Icon
  },
  props: {
    primary: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Navigation"
    },
  },
  computed: {
    buttonClass () {
      return {
        'button button--arrow-primary': this.primary === true,
        'button button--left': this.left === true,
        'button button--right': this.right === true,
      }
    },
    arrowDirection () {
      if (this.left) {
        return 'secondary_arrow_up';
      } else if (this.right) {
        return 'secondary_arrow_up';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.button--arrow-primary {
  &:disabled {
    border-color: $color-black-400;
    span:after {
      background-color: $color-black-400;
    }

    svg {
      opacity: .35;
    }
  }

  @include tablet-up {
    &:hover:not([disabled]) {
      box-sizing: border-box;
      height: 60px;
      width: 104px;
      border: 1px solid #757473;
      border-radius: 30px;
      span {
        width: 70px;
      }
    }
  }

  span {
    position: relative;
    width: 24px;
    transition: all .75s $default-animation-timing;
    &:after {
      height: 1px;
      display: block;
      content: '';
      background-color: $color-divider-dark;
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translateY(-50%);
    }
  }
  svg {
    transform: rotateZ(90deg);
    position: absolute;
  }
}

.button--left {
  svg {
    left: -2px;
    transform: translateY(-50%) rotateZ(90deg) ;
  }
}

.button--right {
  svg {
    right: -2px;
    transform: translateY(-50%) rotateZ(-90deg);
  }
}
</style>
